import React, { useContext, useEffect } from "react";
import styles from "../../../Styles/Login.module.css";
import LoginForm from "./Form";
import UserContext from "../../../context/UserContext";
import { useNavigate } from "react-router-dom";
import logo from "../../../Assets/logo/logo.svg";

function Login() {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user.fetchingAuth && user.isAuth) {
      navigate("/overview"); // Redirect to the overview page
    }
  }, [navigate, user]);

  if (user.fetchingAuth) {
    return <p>Fetching Auth</p>;
  }

  return (
    <div className={styles.login}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.content_left_wrapper}>
            <div className={styles.content_left}>
              <div className={styles.logo_wrapper}>
                <img src={logo} alt="logo" />
                <p className={styles.agent_pro}>Agent Pro</p>
              </div>
            </div>
          </div>
          <div className={styles.content_right_wrapper}>
            <div className={styles.content_right}>
              <p className={styles.welcome_back}>Welcome back!</p>
              <div className={styles.admin}>
                <p className={styles.title}>Admin Login</p>
                <p className={styles.sub_title}>
                  Only for authorized admin users
                </p>
              </div>
              <LoginForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
